var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { width: "102px" } }, [
    _vm.doc.fechaRecepcion !== null
      ? _c("div", [
          _c("span", [
            _vm._v(
              _vm._s(
                _vm._f("moment")(_vm.doc.fechaRecepcion, "DD-MM-YYYY hh:mm")
              )
            )
          ])
        ])
      : _c("div", [_c("span", [_vm._v("Sin información")])])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }